var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0294 10.0089C20.0294 15.2718 15.763 19.5382 10.5001 19.5382C5.23714 19.5382 0.970703 15.2718 0.970703 10.0089C0.970703 4.74593 5.23714 0.479492 10.5001 0.479492C15.763 0.479492 20.0294 4.74593 20.0294 10.0089Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1574 4.97405C7.8737 5.08779 6.68079 6.12214 6.57621 7.99155H8.87935C8.90853 7.34411 9.35967 6.85998 10.2024 6.78805C11.0293 6.71805 11.8124 6.87554 12.0495 7.32661C12.3061 7.81462 11.7297 8.38137 11.4561 8.61954C10.949 9.06089 10.127 9.38266 9.70016 9.85901C9.28185 10.3256 9.20767 10.939 9.17605 11.6905H11.2056C11.2336 11.2103 11.2737 10.7505 11.5473 10.452C11.9924 9.96691 12.6563 9.73944 13.212 9.35642C13.7434 8.98992 14.3028 8.54858 14.3976 7.86614C14.6834 5.82175 12.5967 4.85254 10.1574 4.97405Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93951 12.8116C10.5586 12.8116 11.0606 13.3138 11.0606 13.9327C11.0606 14.5516 10.5586 15.0538 9.93951 15.0538C9.32046 15.0538 8.81841 14.5516 8.81841 13.9327C8.81841 13.3138 9.32046 12.8116 9.93951 12.8116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.14384b03022f0e937ecf5d8dd707be3e.svg";
export { ForwardRef as ReactComponent };